(ns practitest.frontend.components.test-type
  (:require [reagent.core :as reagent]
            ["react-select" :default Select :refer [components]]
            [practitest.frontend.components.icons :as icons]
            [clojure.string :as str]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.i18n :refer [get-translation]]))

(def types-map
  {"ScriptedTest"    {:title (get-translation "test-type.scripted-test" "Scripted Test")
                      :icon  icons/scripted-test}
   "ExploratoryTest" {:title (get-translation "test-type.exploratory-test" "Exploratory Test")
                      :icon  icons/exploratory-test}
   "xBotTest"        {:title (get-translation "test-type.xbot-test" "xBot Test")
                      :icon  icons/xbot-test}
   "FirecrackerTest" {:title (get-translation "test-type.firecracker-test" "Firecracker Test")
                      :icon  icons/firecracker-test}
   "ApiTest"         {:title (get-translation "test-type.api-test" "API Test")
                      :icon  icons/api-test}
   "BDDTest"         {:title (get-translation "test-type.bdd-test" "BDD Test")
                      :icon  icons/bdd-test}})

(defn get-type-label
  [status]
  (:title (get types-map status)))

(defn get-type-icon
  [status]
  (when-let [icon (:icon (get types-map status))]
    [icon]))

(defn type-label
  [type]
  [tooltip/hover-tooltip
   [:<>
    [:span.me-2 (get-type-icon type)]
    (get-type-label type)]
   (get-type-icon type)])
